import axios from 'axios';
import qs from 'qs';
import cookie from 'js-cookie';
import { ENV_CONFIG } from '@laigu/constants';
import jsonpAdapter from './jsonp';

function getCustomMethod(params, method, token) {
  if (window.CUSTOM_CONFIG) {
    const methods = window.CUSTOM_CONFIG[window.CUSTOM_NAME].methods;
    if (method && methods.includes(method.toLowerCase())) {
      params.token = token;
      params._http_method = method;
      method = 'post';
    }
  }
  return method;
}

const fetch = ({
  url,
  method,
  params,
  data,
  headers,
  callbackParamName,
  jsonp,
  baseURL,
  onUploadProgress,
  deleteEntid,
  // 透传 AbortSignal，用于取消在飞请求（慢查询接口必须传，否则废弃的请求仍会在后端跑完）
  signal
}) => {
  const entId = cookie.get('_enterprise_id');
  let queryParams = {
    ...params
  };
  // add by zhanghuan 上传文件不能传ent_id
  if (!deleteEntid && entId) {
    queryParams = {
      ent_id: entId,
      ...queryParams
    };
  }

  method = getCustomMethod(queryParams, method, cookie.get('_authenticated'));

  let options = {
    method,
    url,
    baseURL,
    params: queryParams,
    // add by wangxing 序列化参数
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  };

  // axios 0.19 不支持 config.signal（0.22 才引入），这里把标准 AbortSignal
  // 适配成 CancelToken，让调用方能统一使用 AbortController
  if (signal) {
    const source = axios.CancelToken.source();
    if (signal.aborted) {
      source.cancel();
    } else {
      signal.addEventListener('abort', () => source.cancel(), { once: true });
    }
    options = { ...options, cancelToken: source.token };
  }

  if (!baseURL) {
    options = { ...options, baseURL: `${ENV_CONFIG.MQ_API_URL}` };
  }
  if (headers) {
    headers = {
      ...headers,
      'X-Run-Env': encodeURIComponent(ENV_CONFIG.runEnv),
      'X-Run-Version': encodeURIComponent(ENV_CONFIG.runVersion)
    };
  }
  if (!headers) headers = {};

  if (method === 'jsonp') {
    options = { ...options, jsonp, callbackParamName: callbackParamName || 'c', adapter: jsonpAdapter };
  } else if (method === 'file') {
    const newHeaders = { ...headers };
    options = {
      ...options,
      headers: newHeaders,
      method: 'post',
      data,
      onUploadProgress
    };
  } else {
    const newHeaders = {
      ...headers,
      Accept: 'application/json',
      'Content-Type': headers['Content-Type'] || 'application/json'
    };
    options = { ...options, headers: newHeaders, data: JSON.stringify(data) ?? '' };
  }

  return new Promise((resolve, reject) => {
    axios(options)
      .then(res => {
        const { status } = res;
        if (status >= 200 && status < 300) {
          resolve({ data: res.data });
        }
      })
      .catch(err => {
        // 主动取消（传了 signal 并 abort）不是真实错误，打上标识抛出，
        // 由 configFetch 短路掉错误提示
        if (axios.isCancel(err)) {
          const canceled = new Error('canceled');
          canceled.__CANCELED__ = true;
          reject(canceled);
          return;
        }
        if (err && err.response && err.response.data) {
          reject(err.response);
        }
        reject(`${err}`);
      });
  });
};

export default fetch;
